import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getScope, TargetingScope } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { getPageContainerStyles } from './styles/page-container';
import { SettingsSummaryView } from './settings-summary-view';
import { StyledAllSettingsView } from './all-settings-view';

// eslint-disable-next-line react/prefer-stateless-function
class AllSettings extends React.Component {
  render() {
    const { campaignId, adGroupId } = this.props.scope.values;
    const scope = getScope(campaignId, adGroupId);
    const settingsPageContainerClass = scope === TargetingScope.Account ?
      this.props.classes.pageContainer :
      this.props.classes.pageContainerExpandingToParent;
    return (
      <div className={classNames(['settings-page', settingsPageContainerClass])}>
        {scope === TargetingScope.Account ?
          <SettingsSummaryView {...this.props} /> :
          <StyledAllSettingsView {...this.props} />
        }
      </div>
    );
  }
}

AllSettings.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({}).isRequired,
    CurrentCustomer: PropTypes.shape({}).isRequired,
  }),
  scope: PropTypes.shape({
    values: {
      adGroupId: PropTypes.number,
      campaignId: PropTypes.number,
    },
  }).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.shape({
  }),
  classes: PropTypes.shape({
    pageContainer: PropTypes.string.isRequired,
    pageContainerExpandingToParent: PropTypes.string.isRequired,
  }).isRequired,
  currentCampaign: PropTypes.shape({}),
  currentAdGroup: PropTypes.shape({}),
  preferenceService: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

AllSettings.defaultProps = {
  serverContext: {},
  permissions: {},
  currentCampaign: null,
  currentAdGroup: null,
};

export const StyledSettings =
  withI18nConsumer(withDefaultStyles(AllSettings, () => getPageContainerStyles()));
